import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useNavigate, useLocation, Navigate } from "react-router-dom";
import GoogleCallback from "@/pages/GoogleCallback";
import { Toaster, toast } from "sonner";
import Layout from "@/components/Layout";
import Onboarding from "@/components/Onboarding";
import DayPage from "@/pages/DayPage";
import WeekPage from "@/pages/WeekPage";
import SettingsPage from "@/pages/SettingsPage";
import ReportPage from "@/pages/ReportPage";
import LandingPage from "@/pages/LandingPage";
import AccessPage from "@/pages/AccessPage";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentPages";
import { AuthProvider, useAuth } from "@/lib/auth";

function ProtectedApp({ children }) {
  const { user, loading } = useAuth();
  const nav = useNavigate();
  useEffect(() => {
    if (loading) return;
    if (!user) {
      nav("/", { replace: true });
      return;
    }
    if (!user.paid) {
      toast.error("Devi completare l'acquisto per accedere al planner");
      nav("/", { replace: true });
    }
  }, [user, loading, nav]);
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="font-serif-display italic text-[#8FA087]">un momento…</div>
      </div>
    );
  }
  if (!user || !user.paid) return null;
  return (
    <Layout>
      <Onboarding />
      {children}
    </Layout>
  );
}

function HomeRoute() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="font-serif-display italic text-[#8FA087]">un momento…</div>
      </div>
    );
  }
  // If already paid & authed, jump straight to the planner
  if (user && user.paid) {
    return <Navigate to="/dashboard" replace />;
  }
  return <LandingPage />;
}

function Router() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <GoogleCallback />;
  return (
    <Routes>
      <Route path="/" element={<HomeRoute />} />
      <Route path="/accedi" element={<AccessPage />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/dashboard" element={<ProtectedApp><DayPage /></ProtectedApp>} />
      <Route path="/settimana" element={<ProtectedApp><WeekPage /></ProtectedApp>} />
      <Route path="/report" element={<ProtectedApp><ReportPage /></ProtectedApp>} />
      <Route path="/impostazioni" element={<ProtectedApp><SettingsPage /></ProtectedApp>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Router />
          <Toaster
            position="top-center"
            toastOptions={{
              style: {
                background: "#FFFFFF",
                color: "#3B443D",
                border: "1px solid #E4E7E1",
                fontFamily: "Manrope, sans-serif"
              }
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
